import { TFloorParams, TRoomsParams } from 'common/types/floor-params.type';
import { getAreaUser } from '../../common/helpers/get-area-user.helper';
import { generateRandomId } from '../../../common/helpers/generate-random-id.helper';

type TGetBodyForCalculationStorage = {
  inputParams: TFloorParams;
  calculatorId: string;
  typeInstallation?: string | null;
  isAuthorized: boolean;
};

export const getBodyForCalculationStorage = ({
  inputParams,
  calculatorId,
  typeInstallation,
  isAuthorized,
}: TGetBodyForCalculationStorage): TRoomsParams => {
  const area = getAreaUser(inputParams);
  return {
    calculatorId,
    ...(inputParams.length ? { length: inputParams.length } : undefined),
    ...(inputParams.width ? { width: inputParams.width } : undefined),
    ...(typeInstallation ? { typeInstallation } : undefined),
    square: area,
    createdDate: new Date().toISOString(),
    id: generateRandomId(),
    isAuthorized,
  };
};
